<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{label.reportType}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md6 lg6>
                        <v-autocomplete :items="reportTypes" v-model="form.reportType" :label="label.reportType" item-text="label" item-value="value" data-vv-name="reportType" :data-vv-as="label.reportType" :error-messages="errors.collect('reportType')" v-validate="'required'"></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg6>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{label.dateRange}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="form.tranDateFrom" :label="label.tranDateFrom" :data-vv-as="label.tranDateFrom"
                          data-vv-name="form.tranDateFrom" :error-messages="errors.collect('form.tranDateFrom')" v-validate="tranDateFromValidation"></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="form.tranDateTo" :label="label.tranDateTo" :data-vv-as="label.tranDateTo"
                          data-vv-name="form.tranDateTo" :error-messages="errors.collect('form.tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-layout row wrap>
            <v-flex xs12>
                <v-checkbox
                  :label="label.pbPrtParam"
                  v-model="form.pbPrtParam"
                  :error-messages="errors.collect('pbPrtParam')"
                  data-vv-name="pbPrtParam"
                  :data-vv-as="label.pbPrtParam"
                />
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doSubmit">
            <v-icon left dark>mdi-file-export</v-icon>
              {{label.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
        <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-information</v-icon>
            <v-toolbar-title>System Information</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <span class="info-dialog-msg-header">Oops something went wrong...</span>
              <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      label: {
        reportType: 'Data Extraction For',
        tranDateFrom: 'From Transaction Date*',
        tranDateTo: 'To Transaction Date*',
        dateRange: 'Date Range',
        pbPrtParam: 'Print Runtime Parameters',
        export: 'EXPORT TO'
      },
      form: {
        reportType: 'inwardsPrem',
        tranDateFrom: '',
        tranDateTo: '',
        pbPrtParam: true
      },
      reportTypes: [
        { label: 'Inwards Premium', value: 'inwardsPrem' },
        { label: 'Outwards Premium', value: 'outwardsPrem' },
        { label: 'Claims Movement', value: 'clmMovement' },
        { label: 'Claims Recovery', value: 'clmRcvy' }
      ],
      panel: [0],
      panel2: [0],
      panel3: [0],
      loading: false,
      showErrorDialog: false,
      supportedFormat: []
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      await Promise.all([this.$store.dispatch('accountsInit')])
      await Promise.all([this.$store.dispatch('ifrsDataExtractionInit')])
      this.loading = false
    },
    doCancel() {
      this.$router.push({ name: 'specFuncAcct' }).catch(() => {})
    },
    doSubmit() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.doExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doExport() {
      const apiURI = this.menu.doExport
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.post(apiURI, this.form)
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.showErrorDialog = true
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mixins: [
    MessageMixin
  ],
  computed: {
    menu() {
      return this.$store.state.specFuncAcct.ifrsDataExtraction.menu
    },
    supportedList() {
      const result = []
      result.push(reportFormat.XLSX)
      return result
    },
    tranDateFromValidation() {
      if (this.form.tranDateFrom !== '' && this.form.tranDateFrom !== null && this.form.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.form.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.form.tranDateTo !== '' && this.form.tranDateTo !== null && this.form.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.form.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !(isAfter(removeTime(value), removeTime(tranFromDate)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !(isAfter(removeTime(tranToDate), removeTime(value)))
        }
      }
    })
  }
}
</script>

<style>

</style>
